import { all, fork } from "redux-saga/effects";
import { combineReducers } from "redux";

import {
  reducer as identityReducer,
  saga as identitySaga,
} from "app/modules/identity/_redux";
import { reducer as appReducer, saga as appSaga } from "app/modules/app/_redux";
import {
  reducer as printerReducer,
  saga as printerSaga,
} from "app/modules/printer/_redux";
import { reducer as cameraReducer } from "app/modules/camera/_redux";
import { reducer as adminReducer } from "app/modules/admin/_redux";
import { reducer as truckReducer } from "app/modules/truck/_redux";
import { smsSlice } from "../app/modules/sms/_redux/reducer";
import { tripodSlice } from "../app/modules/tripod/_redux/reducer";
import { barrierSlice } from "../app/modules/barrier/_redux/reducer";
import { wmsReducer } from "app/modules/wms/_redux/reducer";

export const rootReducer = combineReducers({
  // printer: printerReducer,
  identity: identityReducer.reducer,
  app: appReducer.reducer,
  truck: truckReducer.truckReducer,
  printer: printerReducer.reducer,
  dvrs: cameraReducer.dvrSlice.reducer,
  cameraConfig: cameraReducer.cameraConfigByStationReducer,
  admin: adminReducer.adminReducer,
  camera: cameraReducer.cameraSlice.reducer,
  sms: smsSlice.reducer,
  tripod: tripodSlice.reducer,
  barrier: barrierSlice.reducer,
  cameraAI: cameraReducer.cameraAIReducer,
  wms: wmsReducer,
});

export function* rootSaga() {
  yield all([fork(identitySaga), fork(appSaga), fork(printerSaga)]);
}
